const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY

export default googleApiKey
